module.exports = __webpack_public_path__ + "img/close.ba5042ac.svg";